export const GET_SUM = 'GET_SUM';
export const TOGGLE_PROMO_BTN = 'TOGGLE_PROMO_BTN';
export const TYPE_PROMO = 'TYPE_PROMO';
